import classes from './badge.module.scss';

export const Badge = ({ count }: { count: number }) => {
    return count > 0 ? <div className={classes.badge}>{count > 99 ? '99+' : count}</div> : null;
};
